import { render, staticRenderFns } from "./purchase-sales-inventory-report.vue?vue&type=template&id=a896aad2&scoped=true&"
import script from "./purchase-sales-inventory-report.vue?vue&type=script&lang=ts&"
export * from "./purchase-sales-inventory-report.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-sales-inventory-report.vue?vue&type=style&index=0&id=a896aad2&prod&lang=scss&scoped=true&"
import style1 from "./purchase-sales-inventory-report.vue?vue&type=style&index=1&id=a896aad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a896aad2",
  null
  
)

export default component.exports